//@ts-check

class ContractorsRollService {
	constructor($sce, $http, Utility, $timeout, $rootScope, ContentService, LocalStorageService, InternalLinksService) {
		this.$sce = $sce;
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.ContentService = ContentService;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;
		this.init();
	}

	init() {
		this.contractorsRollData = undefined;
		this.contractorsRollTotal = undefined;
	}
	async getContractorsRoll(schemeRef, date) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('FinancialApiContractorsRoll');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/financial/links');
				url = await this.InternalLinksService.getLink('FinancialApiContractorsRoll');
			}

			url = url.replace('{schemeRef}', schemeRef).trim();

			const headers = this.Utility.headersWithContentType;

			if (!!!headers || (!!headers && (!!!headers.userName || !!!headers.sessionToken))) {
				const error = `Could not load Contractors Roll as the 'Username' and/or 'Session Token' is missing`;
				this.$timeout(() => promiseHandler.reject(error));
			}

			const results = await this.$http.post(url, date, { headers });
			const { data } = results;

			this.contractorsRollData = data;
			this.contractorsRollTotal = 0;
			this.contractorsRollData.forEach((value) => {
				this.contractorsRollTotal += value.Amount;
			});
			this.$timeout(() => promiseHandler.resolve());
		} catch (err) {
			this.contractorsRollData = null;
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}
}

export default /* @ngInject */ (
	$sce,
	$http,
	Utility,
	$timeout,
	$rootScope,
	ContentService,
	LocalStorageService,
	InternalLinksService
) =>
	new ContractorsRollService(
		$sce,
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		LocalStorageService,
		InternalLinksService
	);
